import { Component, OnInit } from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    Validators,
    FormControl,
} from '@angular/forms';
import { first } from 'rxjs/internal/operators/first';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
    selector: 'app-add-services',
    templateUrl: './add-services.component.html',
    styleUrls: ['./add-services.component.scss'],
})
export class AddServicesComponent implements OnInit {
    serviceForm!: FormGroup;
    notice!: FormGroup;

    states: any[] = [];
    baseDocTypes: any[] = [];
    LAND_RECORD_SERVICE_ID = 3; //for land records services field

    fieldsData: any[] = [];
    dynamicFields: string[] = [];
    // landRecordSelection: any = {};
    landRecordSelection: {
        [serviceID: number]: {
            [subID: number]: string;
        };
    } = {};


    DataList: any = {};
    isLoading = false;
    isLoading1 = false;

    otherPurposeControl = new FormControl('');
    OTHER_PURPOSE_ID: number = null;


    stateID: any;
    baseDocType: any;
    submitted = false;

    servicesList: any[] = [];
    subTypeList: any = {};
    selectedData: any = {};

    currentUser: any;
    userID: any;

    purposeList: any[] = [];

    selectedPurposeIds: any[] = [];
    isAllSelected = false;

    breadCrumbItems: Array<{}>;

    constructor(
        private fb: FormBuilder,
        private service: GeneralService,
        private router: Router
    ) { }

    get f() {
        return this.serviceForm.controls;
    }

    ngOnInit(): void {
        this.initForm();
        this.loadStates();

        this.breadCrumbItems = [
            { label: 'Users List', path: '/users/users-users' },
            { label: 'User Details', path: '/users/users-users-details' },
            {
                label: 'Add Services',
                path: '/users/users-users-details/services-interest/add',
                active: true,
            },
        ];

        this.getServices();
        this.getCurentUser();
        this.getPurposeList();

        let navigation = this.router.getCurrentNavigation();

        if (navigation && navigation.extras && navigation.extras.state) {
            this.userID = navigation.extras.state['UserId'];
        } else {
            this.userID = history.state.UserId;
        }
        localStorage.setItem('UserId', this.userID);
    }

    getCurentUser() {
        const res = this.service.getcurrentUser();
        if (res) {
            this.currentUser = res.Id || null;
        }
    }

    getPurposeList() {
        this.service.getServicePurpose().subscribe(
            (res: any) => {
                if (res.status === 200 && res.data) {
                    this.purposeList = res.data;
                }

                // "Others"
                const other = this.purposeList.find(
                    (p) => p.PurposeName.toLowerCase() === 'others'
                );

                if (other) {
                    this.OTHER_PURPOSE_ID = other.PurposeID;
                }

            },
            (err) => {
                console.error('PURPOSE API ERROR:', err);
            }
        );
    }

    initForm() {
        this.notice = this.fb.group({});
        this.serviceForm = this.fb.group({
            state: [null, Validators.required],
            baseDocType: [null, Validators.required],
            purpose: [[], Validators.required],
            otherPurpose: [''],
            dynamicData: this.fb.group({}),
            notice: this.notice,
        });
    }

    loadStates() {
        this.service.getState().subscribe((res: any) => {
            this.states = res.data;
        });
    }

    onStateChange(state: any) {
        this.stateID = state;

        this.serviceForm.controls.baseDocType.setValue(null, {
            emitEvent: false,
        });

        this.resetDynamicSystem();

        this.baseDocTypes = [];
        if (state) {
            this.service
                .getStateBaseDocTypeByStateID(state)
                .subscribe((res: any) => {
                    this.baseDocTypes = res.data;
                });
        }
    }

    onBaseDocTypeChange(baseDocTypeID: any) {
        if (!baseDocTypeID) {
            this.baseDocType = null;
            this.resetDynamicSystem();
            return;
        }

        this.baseDocType = baseDocTypeID;
        this.submitted = false;
        this.resetDynamicSystem();

        const params = new URLSearchParams({
            StateID: this.stateID,
            Service_subtype_id: '1',
            StateBaseDocTypeID: baseDocTypeID,
            DisplayLevel: '1',
        });

        this.isLoading1 = true;

        this.service
            .getDynamicFields(params.toString())
            .subscribe((res: any) => {
                this.isLoading1 = false;
                this.fieldsData = res.data || [];

                if (!this.fieldsData.length) return;
                console.log('DYNAMIC FIELDS:', this.fieldsData);
                this.fieldsData.forEach((field) => {
                    this.notice.addControl(
                        field.DBColumnName,
                        this.fb.control(
                            null,
                            field.IsMandatory ? Validators.required : null
                        )
                    );

                    const ctrl = this.notice.get(field.DBColumnName);

                    ctrl.updateValueAndValidity();

                    /* STEP 3: auto-remove Bootstrap invalid class */
                    ctrl.valueChanges.subscribe(() => {
                        if (ctrl.valid) {
                            this.clearInvalid(field.DBColumnName);
                        }
                    });


                    if (field.FieldType === 'Text') return;

                    if (field.FieldType === 'AutoComplete') {
                        this.DataList[field.DBColumnName] = [];
                        return;
                    }

                    if (field.FieldType === 'Dropdown' && field.APIName) {
                        let url = field.APIName;
                        if (url.endsWith('/')) url += this.stateID;
                        if (url.includes('http')) {
                            this.service.dynamicData(url).subscribe((resp: any) => {
                                this.DataList[field.DBColumnName] = resp.data || [];
                            });
                        }
                    };
                });
            });
    }

    createDynamicControls() {
        this.fieldsData.forEach((field) => {
            this.notice.addControl(
                field.DBColumnName,
                new FormControl(
                    '',
                    field.IsMandatory ? Validators.required : null
                )
            );

            if (field.FieldType === 'Dropdown' && field.APIName !== '') {
                this.service
                    .dynamicData(field.APIName)
                    .subscribe((data: any) => {
                        this.DataList[field.DBColumnName] = data.data;
                    });
            }
        });
    }
    resetDynamicSystem() {
        this.fieldsData = [];
        this.DataList = {};

        Object.keys(this.notice.controls).forEach(ctrl => {
            this.notice.removeControl(ctrl);
        });

        this.notice.markAsPristine();
        this.notice.markAsUntouched();
        this.notice.updateValueAndValidity();
    }


    /*  resetDynamicSystem() {
         this.fieldsData = [];
         this.DataList = {};
 
         Object.keys(this.notice.controls).forEach((ctrl) => {
             this.notice.removeControl(ctrl);
         });
     } */

    // onClearField(field: any) {
    //     this.notice.patchValue({
    //         [field.DBColumnName]: null,
    //         BuildingName: null,
    //         villageid: null,
    //         district: null,
    //         taluka: null,
    //     });
    // }

    onClearField(field: any) {
        const ctrl = this.notice.get(field.DBColumnName);
        if (!ctrl) return;

        ctrl.setValue(null);
        ctrl.markAsTouched();
        ctrl.updateValueAndValidity();
    }


    onSearchField(search: string, field: any) {
        if (!search || search.length < 2) {
            this.DataList[field.DBColumnName] = [];
            return;
        }

        if (!this.serviceForm.controls.state.value) {
            Swal.fire({
                title: 'Error',
                text: 'Please Select State',
                type: 'error',
            });
            return;
        }

        this.service
            .areabystateid(field.APIName, search)
            .pipe(first())
            .subscribe((res) => {
                if (res.error) return;

                this.DataList[field.DBColumnName] = res.data;

                this.DataList[field.DBColumnName] = (res.data || []).map(
                    (item) => ({
                        ...item,
                        AreaId: item.VillageId || item.WardID,
                        AreaName:
                            item.Area || item.WardName || item.VillageName,
                    })
                );

                if (res.data.length === 0) {
                    if (this.notice.controls.CityWardNo) {
                        this.notice.controls.CityWardNo.setValue('');
                    }
                    if (this.notice.controls.VillageID) {
                        this.notice.controls.VillageID.setValue('');
                    }
                }
            });
    }

    onVillageSelected(selected: any) {
        if (!selected) {
            this.DataList['BuildingName'] = [];
            this.notice.controls['BuildingName'].setValue(null);
            return;
        }

        const VillageID = selected.VillageId;
        const WardID = selected.WardID;
        const CityID = selected.ID;

        if (WardID) {
            this.service.SocietylistUrban(WardID).subscribe((res: any) => {
                this.DataList['BuildingName'] = res.data || [];
            });
            return;
        }

        if (VillageID) {
            this.service.Societylist(VillageID).subscribe((res: any) => {
                this.DataList['BuildingName'] = res.data || [];
            });
            return;
        }

        if (CityID) {
            this.service.SocietylistGoaUrban(CityID).subscribe((res: any) => {
                this.DataList['BuildingName'] = res.data || [];
            });
        }
    }

    getServices() {
        this.service.getservices().subscribe((res: any) => {
            this.servicesList = res.data;
        });
    }

    toggleService(serviceID: number, event: any) {
        if (event.target.checked) {
            this.selectedData[serviceID] = [];

            this.service
                .getServicesSubType(serviceID, this.stateID)
                .subscribe((res: any) => {
                    this.subTypeList[serviceID] = res.data;
                });
        } else {
            delete this.selectedData[serviceID];
            delete this.subTypeList[serviceID];
        }
    }

    // toggleSubService(serviceID: number, subID: number, event: any) {
    //     if (event.target.checked) {
    //         this.selectedData[serviceID].push(subID);
    //     } else {
    //         this.selectedData[serviceID] = this.selectedData[serviceID].filter(
    //             (x) => x !== subID
    //         );
    //     }
    // }

    // toggleSubService(serviceID: number, subID: number, event: any) {
    //     if (event.target.checked) {
    //         this.selectedData[serviceID].push(subID);

    //         // ✅ Only for Land Records
    //         if (serviceID === this.LAND_RECORD_SERVICE_ID) {
    //             if (!this.landRecordSelection[serviceID]) {
    //                 this.landRecordSelection[serviceID] = {};
    //             }

    //             // default = Certified
    //             this.landRecordSelection[serviceID][subID] = 'Certified';
    //         }

    //     } else {
    //         this.selectedData[serviceID] =
    //             this.selectedData[serviceID].filter(x => x !== subID);

    //         // remove from certified map
    //         if (
    //             serviceID === this.LAND_RECORD_SERVICE_ID &&
    //             this.landRecordSelection[serviceID]
    //         ) {
    //             delete this.landRecordSelection[serviceID][subID];
    //         }
    //     }
    // }

    toggleSubService(serviceID: number, subID: number, event: any) {
        if (event.target.checked) {
            this.selectedData[serviceID].push(subID);

            // ✅ Only for Land Records
            if (serviceID === this.LAND_RECORD_SERVICE_ID) {
                if (!this.landRecordSelection[serviceID]) {
                    this.landRecordSelection[serviceID] = {};
                }

                // default = Certified
                this.landRecordSelection[serviceID][subID] = 'Certified';
            }

        } else {
            this.selectedData[serviceID] =
                this.selectedData[serviceID].filter(x => x !== subID);

            // remove radio selection also
            if (
                serviceID === this.LAND_RECORD_SERVICE_ID &&
                this.landRecordSelection[serviceID]
            ) {
                delete this.landRecordSelection[serviceID][subID];
            }
        }
    }

    onCertTypeChange(serviceID: number, subID: number, value: string) {
        if (!this.landRecordSelection[serviceID]) {
            this.landRecordSelection[serviceID] = {};
        }

        this.landRecordSelection[serviceID][subID] = value;
    }

    getDynamicFieldPayload() {
        const dynamicResult = [];

        this.fieldsData.forEach((field) => {
            const col = field.DBColumnName;
            const value = this.serviceForm.get('notice.' + col).value;

            if (value !== null && value !== undefined && value !== '') {
                let fieldNameToSend = col;
                if (field.Placeholder === 'Ward' && col === 'VillageID') {
                    fieldNameToSend = 'CityWardNo';
                }
                dynamicResult.push({
                    FieldName: fieldNameToSend,
                    FieldValue: value,
                });
            }
        });

        return dynamicResult;
    }

    // onPurposeChange(selected: any) {
    //     if (selected.includes('all')) {
    //         if (!this.isAllSelected) {
    //             this.isAllSelected = true;
    //             this.selectedPurposeIds = this.purposeList.map(
    //                 (p) => p.PurposeID
    //             );

    //             this.serviceForm.controls['purpose'].setValue(
    //                 [...this.selectedPurposeIds],
    //                 { emitEvent: false }
    //             );
    //             this.serviceForm.controls['purpose'].updateValueAndValidity();

    //         } else {
    //             this.isAllSelected = false;
    //             this.selectedPurposeIds = [];

    //             this.serviceForm.controls['purpose'].setValue([], {
    //                 emitEvent: false,
    //             });
    //             this.serviceForm.controls['purpose'].updateValueAndValidity();

    //         }
    //         return;
    //     }
    //     this.selectedPurposeIds = selected;
    //     this.isAllSelected =
    //         this.selectedPurposeIds.length === this.purposeList.length;
    // }

    onPurposeChange(selected: any) {

        // ✅ HANDLE SELECT ALL
        if (selected && selected.includes('all')) {

            if (!this.isAllSelected) {
                this.isAllSelected = true;

                this.selectedPurposeIds = this.purposeList.map(
                    (p) => p.PurposeID
                );

                this.serviceForm.controls['purpose'].setValue(
                    this.selectedPurposeIds,
                    { emitEvent: false }
                );

            } else {
                this.isAllSelected = false;
                this.selectedPurposeIds = [];

                this.serviceForm.controls['purpose'].setValue([], {
                    emitEvent: false,
                });
            }

        } else {
            // ✅ NORMAL SELECTION
            this.selectedPurposeIds = selected || [];

            this.isAllSelected =
                this.selectedPurposeIds.length === this.purposeList.length;
        }

        // ✅ HANDLE "OTHERS" FIELD LOGIC
        if (
            this.OTHER_PURPOSE_ID &&
            this.selectedPurposeIds.includes(this.OTHER_PURPOSE_ID)
        ) {
            // add required validator
            this.serviceForm
                .get('otherPurpose')
                .setValidators([Validators.required]);

        } else {
            // remove validator + clear value
            this.serviceForm.get('otherPurpose').clearValidators();
            this.serviceForm.get('otherPurpose').setValue('');
        }

        // ✅ UPDATE VALIDITY
        this.serviceForm.get('otherPurpose').updateValueAndValidity();
    }

    getPurposeLabel(items: any[]): string {
        if (!items || items.length === 0) return 'Select Purpose';

        const selectedNames = items
            .map((PurposeID) => {
                const match = this.purposeList.find(
                    (p) => p.PurposeID === PurposeID
                );
                return match ? match.PurposeName : null;
            })
            .filter((PurposeName) => PurposeName);

        return selectedNames.join(', ');
    }

    get isAllSelecteded(): boolean {
        return this.selectedPurposeIds.length === this.purposeList.length;
    }

    toggleSelectAll() {
        if (this.isAllSelected) {
            this.selectedPurposeIds = [];
        } else {
            this.selectedPurposeIds = this.purposeList.map((p) => p.PurposeID);
        }

        this.isAllSelected = !this.isAllSelected;

        this.serviceForm.controls['purpose'].setValue([
            ...this.selectedPurposeIds,
        ]);
        this.serviceForm.controls['purpose'].updateValueAndValidity();
    }

    toggleSingle(id: number, event: any) {
        event.stopPropagation();

        if (this.selectedPurposeIds.includes(id)) {
            this.selectedPurposeIds = this.selectedPurposeIds.filter(
                (x) => x !== id
            );
        } else {
            this.selectedPurposeIds.push(id);
        }

        this.isAllSelected =
            this.selectedPurposeIds.length === this.purposeList.length;

        this.serviceForm.controls['purpose'].setValue([
            ...this.selectedPurposeIds,
        ]);
        this.serviceForm.controls['purpose'].updateValueAndValidity();
    }

    private getMissingDynamicRequiredFields(): string[] {
        const missing: string[] = [];

        this.fieldsData.forEach(field => {
            if (!field.IsMandatory) return;

            const ctrl = this.notice.get(field.DBColumnName);
            const value = ctrl.value;

            if (
                value === null ||
                value === undefined ||
                value === '' ||
                (Array.isArray(value) && value.length === 0)
            ) {
                missing.push(field.Placeholder || field.DBColumnName);
            }
        });

        return missing;
    }

    private markInvalid(fieldName: string) {
        setTimeout(() => {
            const el = document.querySelector(
                `[formcontrolname="${fieldName}"]`
            ) as HTMLElement;

            if (!el) return;

            // ng-select
            if (el.tagName.toLowerCase() === 'ng-select') {
                const container = el.querySelector('.ng-select-container');
                container.classList.add('is-invalid');
                return;
            }

            // normal input
            el.classList.add('is-invalid');
        });
    }

    private clearInvalid(fieldName: string) {
        setTimeout(() => {
            const el = document.querySelector(
                `[formcontrolname="${fieldName}"]`
            ) as HTMLElement;

            if (!el) return;

            if (el.tagName.toLowerCase() === 'ng-select') {
                const container = el.querySelector('.ng-select-container');
                container.classList.remove('is-invalid');
                return;
            }

            el.classList.remove('is-invalid');
        });
    }



    submitForm() {
        /*  this.submitted = true;
         this.isLoading = true;
 
         if (this.serviceForm.invalid) {
             this.serviceForm.markAllAsTouched();
             this.notice.markAllAsTouched();
             this.isLoading = false;
 
             return;
         }
  */
        const formValue = this.serviceForm.value;

        /* const payload = {
            UserID: this.userID,
            StateID: formValue.state,
            BaseDocTypeID: formValue.baseDocType,
            created_by: this.currentUser,

            Purpose: this.selectedPurposeIds,

            Services: this.selectedData,

            DynamicFields: this.getDynamicFieldPayload(),
        };

        console.log('FINAL PAYLOAD: ', payload);
 */

        this.submitted = true;
        this.isLoading = true;

        this.serviceForm.markAllAsTouched();
        this.notice.markAllAsTouched();

        if (this.serviceForm.invalid || this.notice.invalid) {
            this.isLoading = false;

            const missingDynamicFields = this.getMissingDynamicRequiredFields();
            this.fieldsData.forEach(field => {
                const ctrl = this.notice.get(field.DBColumnName);

                if (field.IsMandatory && ctrl.invalid) {
                    this.markInvalid(field.DBColumnName);
                } else {
                    this.clearInvalid(field.DBColumnName);
                }
            });

            if (missingDynamicFields.length > 0) {
                this.isLoading = false;

                Swal.fire({
                    type: 'error',
                    title: 'Missing Required Details',
                    html: `
                <div style="text-align:left">
                    <p>Please fill the following required fields:</p>
                    <ul>
                        ${missingDynamicFields
                            .map(f => `<li><b>${f}</b></li>`)
                            .join('')}
                    </ul>
                </div>
            `,
                });

                return;
            }

            return;
        }

        // Only require the free-text "Other Purpose" when the "Others" purpose is
        // actually selected. (Precedence fix: && binds tighter than ||, so without
        // the parentheses the empty-check fired for ANY purpose, e.g. "Personal Record".)
        if (
            this.OTHER_PURPOSE_ID &&
            this.selectedPurposeIds.includes(this.OTHER_PURPOSE_ID) &&
            (!this.serviceForm.value.otherPurpose ||
                String(this.serviceForm.value.otherPurpose).trim() === '')
        ) {
            this.isLoading = false;

            Swal.fire({
                type: 'error',
                title: 'Other Purpose Required',
                text: 'Please enter Other Purpose.',
            });

            return;
        }

        const finalServices = { ...this.selectedData };

        // ✅ transform only Land Records
        // if (finalServices[this.LAND_RECORD_SERVICE_ID]) {
        //     const transformed = [];

        //     finalServices[this.LAND_RECORD_SERVICE_ID].forEach((subID: number) => {
        //         const type =
        //             this.landRecordSelection?.[this.LAND_RECORD_SERVICE_ID]?.[subID] ||
        //             'Certified';

        //         transformed.push({ [subID]: type });
        //     });

        //     finalServices[this.LAND_RECORD_SERVICE_ID] = transformed;
        // }

        if (finalServices[this.LAND_RECORD_SERVICE_ID]) {

            const transformed = [];

            finalServices[this.LAND_RECORD_SERVICE_ID].forEach((subID: number) => {

                let type = 'Certified';

                if (
                    this.landRecordSelection &&
                    this.landRecordSelection[this.LAND_RECORD_SERVICE_ID] &&
                    this.landRecordSelection[this.LAND_RECORD_SERVICE_ID][subID]
                ) {
                    type = this.landRecordSelection[this.LAND_RECORD_SERVICE_ID][subID];
                }

                const obj = {};
                obj[subID] = type;

                transformed.push(obj);
            });

            finalServices[this.LAND_RECORD_SERVICE_ID] = transformed;
        }

        // Always a STRING — the backend calls OtherPurpose.trim(). Empty string when
        // "Others" isn't selected (previously an empty object {}, which crashed
        // the API with "req.body.OtherPurpose?.trim is not a function").
        let otherPurposePayload = '';

        if (
            this.OTHER_PURPOSE_ID &&
            this.selectedPurposeIds.includes(this.OTHER_PURPOSE_ID)
        ) {
            const value = this.serviceForm.value.otherPurpose;

            if (value && String(value).trim() !== '') {
                otherPurposePayload = String(value).trim();
            }
        }

        const payload = {
            UserID: this.userID,
            StateID: this.serviceForm.value.state,
            BaseDocTypeID: this.serviceForm.value.baseDocType,
            created_by: this.currentUser,
            Purpose: this.selectedPurposeIds,
            OtherPurpose: otherPurposePayload,
            Services: finalServices,
            DynamicFields: this.getDynamicFieldPayload(),
        };


        console.log('FINAL PAYLOAD:', payload);
        if (!this.userID) {
            this.isLoading = false;
            Swal.fire({
                type: 'error',
                title: 'User ID Missing',
                text: 'User ID not found. Please try again.',
            });
            return;
        } else {
            this.isLoading = false;

            this.service.postServices(payload).subscribe(
                (res: any) => {
                    Swal.fire({
                        type: 'success',
                        title: 'Services Uploaded',
                        text: res.message,
                    });
                    localStorage.setItem('UserId', this.userID);
                    this.router.navigate(
                        ['users/users-users-details/services-interest'],
                        {
                            state: {
                                id: this.userID,
                            },
                        }
                    );
                },
                (err) => {
                    console.log('ERROR', err);
                    Swal.fire({
                        type: 'error',
                        title: 'Upload Failed',
                        text: err.message || 'Something went wrong!',
                    });
                }
            );
        }
    }
}
